import OnboardingCoachNotificationsContext from './OnboardingCoachNotificationsContext';

export default OnboardingCoachNotificationsContext;

export * from './withOnboardingCoachNotificationsContext';
